import CustomScroll from "@src/component/customScroll"
import { ORDER_STATUS } from "@src/config"
import { goto } from "@src/route"
import { getOrderList } from "@src/service/ownService"
import { Toast } from "antd-mobile"
import moment from "moment"
import { memo, useEffect, useState } from "react"
import "./index.scss"

const MiApply = () => {
  const [data, setData] = useState<any[]>([])
  // const [xykName, setXykName] =  useState<string>('')
  useEffect(() => {
    document.title = "分期申请"
  }, [])

  useEffect(() => {
    getList()
  }, [])

  const getList = async () => {
    try {
      const list = await getOrderList()
      setData(list)
    } catch (err: any) {
      Toast.show(err?.errmsg)
    }
  }

  /**
   * 金额格式化
   * @param s 传入数字
   * @param n 保留几位小数
   * @returns
   */
  const fmoney = (s: string, n: number) => {
    n = n > 0 && n <= 20 ? n : 2
    s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + ""
    const l = s.split(".")[0].split("").reverse(),
      r = s.split(".")[1]
    let t = ""
    for (let i = 0; i < l.length; i++) {
      t += l[i] + ((i + 1) % 3 == 0 && i + 1 != l.length ? "," : "")
    }
    return t.split("").reverse().join("") + "." + r
  }

  // const setName = async() => {
  //   try {
  //     const qrs = await qualificationResult()
  //     if (qrs?.isCreditCard && qrs?.creditLimitType) {
  //       setXykName('信用卡')
  //     } else {
  //       setXykName(ORDER_STATUS[5])
  //     }
  //   } catch (error: any) {
  //     Toast.show(error?.errmsg || "")
  //   }
  //   getList();
  // }

  return (
    <div className="page bottomFit MiApply">
      <CustomScroll>
        <div className="apply-num">共{data?.length || 0}笔</div>
        <ul>
          {data &&
            data.map((_ele, _index) => (
              <li
                key={_index}
                onClick={() => {
                  goto("/order/orderDetail", {
                    loanid: _ele.loanid,
                    no: _ele.no,
                  })
                }}
                className="apply-box"
              >
                <div className="box-title">
                  <p>
                    单号：<span>{_ele?.no}</span>
                  </p>
                  <p>{ORDER_STATUS[_ele?.status]}</p>
                </div>
                <div className="box-content">
                  <div className="content-text">
                    <h2>￥{fmoney(_ele?.netPrice, 2)}</h2>
                    <p>{moment(_ele?.mktime).format("YYYY年MM月DD日")}</p>
                  </div>
                  <div className="content-icon"></div>
                </div>
              </li>
            ))}
        </ul>
      </CustomScroll>
    </div>
  )
}

export default memo(MiApply)
